
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"clip-path":"url(#a)","transform":"translate(2081 1782)","fill":"none","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","stroke":"#e9e9eb","transform":"translate(-2077 -1778)"}}),_c('path',{attrs:{"stroke":"#2c2c30","stroke-linecap":"round","d":"M-2069-1778.031a8.031 8.031 0 11-8.031 8.031"}})])])
          )
        }
      }
    